<div id="create-new-invoice-wrap" class="new-create">
	<!-- (click)="changeTab.emit('all-invoices')" -->
	<span class="back_to_invoice">
		<a routerLink="/invoices" href="javascript:;" class="back_to_invoice">
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
				<path d="M10.7304 17.3118C10.4304 17.6118 10.0235 17.7803 9.59922 17.7803C9.17496 17.7803 8.76806 17.6118 8.46802 17.3118L1.26802 10.1118C0.968065 9.81177 0.799561 9.40488 0.799561 8.98061C0.799561 8.55635 0.968065 8.14946 1.26802 7.84942L8.46802 0.649416C8.76978 0.357962 9.17395 0.196692 9.59346 0.200336C10.013 0.203983 10.4143 0.372252 10.7109 0.668905C11.0076 0.965559 11.1759 1.36686 11.1795 1.78637C11.1831 2.20589 11.0219 2.61005 10.7304 2.91181L6.39922 7.38062L21.5992 7.38062C22.0236 7.38062 22.4305 7.54919 22.7306 7.84924C23.0306 8.1493 23.1992 8.55627 23.1992 8.98061C23.1992 9.40496 23.0306 9.81193 22.7306 10.112C22.4305 10.412 22.0236 10.5806 21.5992 10.5806L6.39922 10.5806L10.7304 15.0494C11.0304 15.3495 11.1989 15.7564 11.1989 16.1806C11.1989 16.6049 11.0304 17.0118 10.7304 17.3118Z" fill="#1AACD9"/>
			</svg>
			<ng-container i18n="@@common.back">Back</ng-container>
		</a>
	</span>

	<form class="" [formGroup]="invoiceForm" (ngSubmit)="saveInvoice()">
		<div data-id="b2b-group-content" class="invoice_type-content active">
			<div class="new-create__main">
				<div class="new-create__form">
					<div class="new-create__form-header">
						<div class="new-create__form-header--left">
							<h3>#{{ invoiceForm?.value?.invoice_number }}</h3>
							<!-- <div class="status">
								<div class="order_unpaid order_status">
									<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
										<circle cx="4" cy="4" r="4" fill="#18F121"/>
									</svg>
									<ng-container i18n="@@ts.unpaid">Unpaid</ng-container>
								</div>
							</div>
							<svg class="dots_menu" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
								<path d="M14.3999 24.3999C14.3999 23.8695 14.6106 23.3608 14.9857 22.9857C15.3608 22.6106 15.8695 22.3999 16.3999 22.3999C16.9303 22.3999 17.439 22.6106 17.8141 22.9857C18.1892 23.3608 18.3999 23.8695 18.3999 24.3999C18.3999 24.9303 18.1892 25.439 17.8141 25.8141C17.439 26.1892 16.9303 26.3999 16.3999 26.3999C15.8695 26.3999 15.3608 26.1892 14.9857 25.8141C14.6106 25.439 14.3999 24.9303 14.3999 24.3999ZM14.3999 16.3999C14.3999 15.8695 14.6106 15.3608 14.9857 14.9857C15.3608 14.6106 15.8695 14.3999 16.3999 14.3999C16.9303 14.3999 17.439 14.6106 17.8141 14.9857C18.1892 15.3608 18.3999 15.8695 18.3999 16.3999C18.3999 16.9303 18.1892 17.439 17.8141 17.8141C17.439 18.1892 16.9303 18.3999 16.3999 18.3999C15.8695 18.3999 15.3608 18.1892 14.9857 17.8141C14.6106 17.439 14.3999 16.9303 14.3999 16.3999ZM14.3999 8.3999C14.3999 7.86947 14.6106 7.36076 14.9857 6.98569C15.3608 6.61062 15.8695 6.3999 16.3999 6.3999C16.9303 6.3999 17.439 6.61062 17.8141 6.98569C18.1892 7.36076 18.3999 7.86947 18.3999 8.3999C18.3999 8.93034 18.1892 9.43904 17.8141 9.81412C17.439 10.1892 16.9303 10.3999 16.3999 10.3999C15.8695 10.3999 15.3608 10.1892 14.9857 9.81412C14.6106 9.43904 14.3999 8.93034 14.3999 8.3999Z" fill="black"/>
							</svg> -->
						</div>
						<div class="new-create__form-header--right">
							<ul class="invoice_type_list" data-group="b2c-group">
								<li data-target="b2b-tab" class="invoice_type-item" [ngClass]="{'active': invoiceForm?.value?.invoice_type == 'b2b'}" (click)="changeInvoiceType('b2b')" i18n="@@invoices.b2b_invoice">B2B Invoice</li>
								<li data-target="b2c-tab" class="invoice_type-item" [ngClass]="{'active': invoiceForm?.value?.invoice_type == 'b2c'}" (click)="changeInvoiceType('b2c')" i18n="@@invoices.b2c_invoice">B2C Invoice</li>
							</ul>
						</div>
					</div>

					<div class="d-flex flex-column gap-4 p-4 bg-white rounded-4 gap-none-3 bg-none-transparent rounded-none-0 p-none-0">
						<div class="d-flex gap-3 align-items-center flex-none-column">
							<div class="new-create__items" *ngIf="isTaxInvoice">
								<fieldset class="add-items" [ngClass]="{'has-error': submitted && invoiceForm.controls.tax_type.errors }" >
									<label for="search" i18n="@@invoices.tax_type">Tax Type</label>
									<select class="select-clientsSelect" nice-select [(ngModel)]="taxIncludesValues" (ngModelChange)="isTaxInclusive($event)" formControlName="tax_type">
										<option *ngFor="let item of taxIncludeTypes" [value]="item.id">{{ item.name }}</option>
									</select>
									<span class="field-error" i18n="@@error.required">* Required</span>
									<span class="field-error" *ngIf="invoiceForm.controls.tax_type.errors && invoiceForm.controls.tax_type.errors?.serverError">{{ invoiceForm.controls.tax_type.errors?.serverError }}</span>
								</fieldset>
							</div>
							<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.invoice_number.errors }">
								<label for="invoice-number" i18n="@@invoices.invoice_number">Invoice Number</label>
								<input type="number" appPreventScroll class="red-txt new-create__regularinput" formControlName="invoice_number" i18n-placeholder="@@invoices.invoice_number" placeholder="Invoice No." />
								<span class="field-error" *ngIf="invoiceForm.controls.invoice_number.errors && invoiceForm.controls.invoice_number.errors?.serverError">{{ invoiceForm.controls.invoice_number.errors?.serverError }}</span>
								<span class="field-error" *ngIf="invoiceForm.controls.invoice_number.errors && !invoiceForm.controls.invoice_number.errors?.serverError" i18n="@@error.required">* Required</span>
							</fieldset>
							<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.invoice_date.errors && invoiceForm.controls.invoice_date.errors.required}">
								<div class="date-input-wrap create-invoces-date">
									<label for="invoice-date" i18n="@@invoices.invoice_date">Invoice date</label>
									<input type="text" date-dropper formControlName="invoice_date" data-large-default="true" class="date-input datedropper-init new-create__regularinput" data-theme="teamup" data-dd-format="d/m/Y" id="invoiceDate" />
								</div>
								<span class="field-error" i18n="@@error.required">* Required</span>
							</fieldset>
							<ng-container *ngIf="invoiceForm?.value?.invoice_type == 'b2b'">
								<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.invoice_time.errors && invoiceForm.controls.invoice_time.errors.required}">
									<label for="invoice-date" class="nowrap" i18n="@@invoices.invoice_time">Invoice Time</label>
									<input type="time" formControlName="invoice_time" min="00:00" max="23:59" class="new-create__regularinput d-block" onfocus="this.showPicker()"/>
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
							</ng-container>
						</div>

						<div class="d-flex gap-3 align-items-center flex-none-column">
							<fieldset [ngClass]="{'has-error': invoiceForm.controls.tax_percent.errors}" *ngIf="isTaxInvoice && taxIncludesValues != 3" >
								<div class="input_wrapper w-none-100">
									<label for="minimumordersize" i18n="@@invoices.tax_rate">Tax Rate</label>
									<label for="minimumordersize" class="input-after">%</label>
									<input type="number" appPreventScroll id="minimumordersize" formControlName="tax_percent" placeholder="Tax Rate" i18n-placeholder="@@invoices.tax_rate">
								</div>
								<span class="field-error" *ngIf="invoiceForm.controls.tax_percent.errors?.required" i18n="@@error.required">* Required</span>
								<span class="field-error" *ngIf="invoiceForm.controls.tax_percent.errors?.max || invoiceForm.controls.tax_percent.errors?.min" i18n="@@error.invalid_number">Invalid</span>
							</fieldset>

							<div class="new-create__items">
								<fieldset class="add-items" [ngClass]="{'has-error': submitted && invoiceForm.controls.client_id.errors && invoiceForm.controls.client_id.errors.required}">
									<label for="search" i18n="@@invoices.client">Client</label>
									<select app-select2
										[options]="{
												ajax: {url: clientListApi},
												idColumn: 'id',
												textColumn: 'full_name'
											}"
										(itemSelected)="onChangeClient($event)"
										[selected]="selectedClient ? {id: selectedClient.id, text: selectedClient.full_name} : null"
										i18n-data-placeholder="@@option.select_client"
										data-placeholder="Select Client"
										formControlName="client_id"
										[showAddNewItem]="'true'"
										[addNewItemTitle]="addNewClientTitle"
										class="select-clientsSelect">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
							</div>
						</div>

						<div class="b2b_buyer_info" *ngIf="invoiceForm?.value?.invoice_type == 'b2b'">
							<h4 i18n="@@invoices.buyer_info">Buyer info</h4>
							<div class="d-flex gap-3 align-items-center w-100 flex-none-column">
								<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.buyer_first_name.errors }">
									<label for="buyer-name" i18n="@@invoices.buyer_first_name">First Name</label>
									<input class="new-create__regularinput" type="text" name="buyer-name" formControlName="buyer_first_name" />
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
								<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.buyer_last_name.errors }">
									<label for="buyer-surname" i18n="@@invoices.buyer_last_name">Last Name</label>
									<input class="new-create__regularinput" type="text" name="buyer-surname" formControlName="buyer_last_name" />
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
								<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.buyer_address.errors }">
									<label for="buyer-address" i18n="@@invoices.address">Address</label>
									<input class="new-create__regularinput" type="text" name="buyer-address" formControlName="buyer_address" />
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
							</div>
							<div class="d-flex gap-3 align-items-center w-100 flex-none-column">
								<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.buyer_vat_number.errors }">
									<label for="buyer-vat" i18n="@@invoices.vat_number">VAT Number</label>
									<input class="new-create__regularinput" type="text" name="buyer-vat" formControlName="buyer_vat_number" />
									<span class="field-error" *ngIf="invoiceForm.controls.buyer_vat_number.errors?.required" i18n="@@error.required">* Required</span>
									<span class="field-error" *ngIf="invoiceForm.controls.buyer_vat_number.errors?.max || invoiceForm.controls.buyer_vat_number.errors?.pattern" i18n="@@validation.errors.enter_valid_organization_id">Must be 15 digits, start with 3 and end with 3</span>
								</fieldset>
								<fieldset [ngClass]="{'has-error': submitted && invoiceForm.controls.buyer_cr_number.errors }">
									<label for="buyer-cr" i18n="@@invoices.cr_number">CR Number</label>
									<input class="new-create__regularinput" type="text" name="buyer-cr" formControlName="buyer_cr_number" />
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
							</div>
						</div>

						<div class="d-flex flex-column gap-2">
							<div class="d-flex gap-3">
								<div class="new-create__items w-50 w-none-100">
									<label for="d-select-items2" i18n="@@invoices.items">Items</label>
									<div class="new-create__items">
										<invoice-deliverable-form
											[invoiceForm]="invoiceForm"
											[form]="deliverableForm"
											[formType]="'addNew'"
											(onSubmit)="addDeliverable($event)"
											[formId]="'create-deliverable'"
											[deliverableList]="productAndServices"
										></invoice-deliverable-form>
									</div>
								</div>
								<div class="w-50 d-none-none"></div>
							</div>

							<div class="d-flex align-items-center gap-3 flex-none-column">
								<div class="new-create-selectedItems new-create__items">
									<ng-container *ngFor="let deliverable of deliverables?.controls; index as $index">
										<div class="new-create-selectedItems__wrapper w-50 w-none-100" [formGroup]="deliverable">
											<span>{{ deliverable.controls.title.value | titlecase }}</span>
											<div class="d-flex w-100 justify-content-between flex-none-column gap-none-3">
												<div class="checkbox_cont" *ngIf="invoiceForm.controls.include_tax.value">
													<div class="custom-checkbox filters_checkbox">
														<input id="filters_checkbox" type="checkbox" class="select-item" [checked]="deliverable.controls.is_taxable.value" name="tax" formControlName="is_taxable">
														<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
															<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
														</svg>
														<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
															<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
														</svg>
													</div>
													<ng-container i18n="@@invoices.apply_tax_on_item">Apply taxes on this item</ng-container>
												</div>
												<div class="d-flex gap-2 align-items-center">
													<div class="added_to_cart_block">
														<span class="minus counter" (click)="changeQuantity(deliverable,'minus')" >
															<svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
																<path d="M14 7.53298H2V6.46631H14V7.53298Z" fill="black"/>
															</svg>
														</span>
														<input type="number" (ngModelChange)="changeInputQuantity(deliverable)" (change)="changeInputQuantityIfValueNullOrZero(deliverable)"  name="quantity" class="new-create-selectedItems__quantityValue" min="0" formControlName="quantity" [ngClass]="{'error': deliverable.get('quantity').invalid }" placeholder="0" autocomplete="off">
														<span class="plus counter" (click)="changeQuantity(deliverable,'plus')">
															<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
																<path d="M8 2C8.19891 2 8.38968 2.07902 8.53033 2.21967C8.67098 2.36032 8.75 2.55109 8.75 2.75V7.25H13.25C13.4489 7.25 13.6397 7.32902 13.7803 7.46967C13.921 7.61032 14 7.80109 14 8C14 8.19891 13.921 8.38968 13.7803 8.53033C13.6397 8.67098 13.4489 8.75 13.25 8.75H8.75V13.25C8.75 13.4489 8.67098 13.6397 8.53033 13.7803C8.38968 13.921 8.19891 14 8 14C7.80109 14 7.61032 13.921 7.46967 13.7803C7.32902 13.6397 7.25 13.4489 7.25 13.25V8.75H2.75C2.55109 8.75 2.36032 8.67098 2.21967 8.53033C2.07902 8.38968 2 8.19891 2 8C2 7.80109 2.07902 7.61032 2.21967 7.46967C2.36032 7.32902 2.55109 7.25 2.75 7.25H7.25V2.75C7.25 2.55109 7.32902 2.36032 7.46967 2.21967C7.61032 2.07902 7.80109 2 8 2Z" fill="black"/>
															</svg>
														</span>
													</div>
													<svg  (click)="removeDeliverable($index)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
														<path d="M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
												</div>
											</div>
										</div>
									</ng-container>
								</div>
							</div>
						</div>

						<div class="d-flex align-items-center gap-3 flex-none-column">
							<fieldset [ngClass]="{'has-error':invoiceForm.controls.discount.errors}">
								<div class="w-100 service_hide w-none-100">
									<label for="discount-input" i18n="@@invoices.discount">Discount</label>
									<div class="position-relative mt-1">
										<input type="number" appPreventScroll class="new-create__regularinput" formControlName="discount" (ngModelChange)="changeDiscount($event)" />
										<div class="discount-type-toggle">
											<span class="discount-type" data-type="percent" [ngClass]="{'active': discountType == 'percentage'}" (click)="changeDiscountType('percentage')">%</span>
											<span class="discount-type pt-12" data-type="sar" [ngClass]="{'active': discountType == 'amount'}" (click)="changeDiscountType('amount')" [innerHtml]="userInfo?.currency_symbol"></span>
										</div>
									</div>
									<span class="field-error" *ngIf="invoiceForm.controls.discount.errors?.min && discountType == 'percentage'" i18n="@@error.invalid_discount">Please enter valid discount (1-100)</span>
									<span class="field-error" *ngIf="invoiceForm.controls.discount.errors?.max  && discountType == 'percentage'" i18n="@@error.invalid_discount">Please enter valid discount (1-100)</span>
									<span class="field-error" *ngIf="invoiceForm.controls.discount.errors?.min && discountType == 'amount'" i18n="@@error.invalid_discount_dynamic">Please enter valid discount (0-{{subTotalDeliverableCost}})</span>
									<span class="field-error" *ngIf="invoiceForm.controls.discount.errors?.max  && discountType == 'amount'" i18n="@@error.invalid_discount_dynamic">Please enter valid discount (0-{{subTotalDeliverableCost}})</span>
								</div>
							</fieldset>
							<fieldset [ngClass]="{'has-error':invoiceForm.controls.delivery_fee.errors}" >
								<div class="w-100 service_hide w-none-100">
									<label for="delivery-fee-input" i18n="@@invoices.delivery_fee">Delivery fees</label>
									<div class="position-relative mt-1">
										<input id="delivery-fee-input" type="number" appPreventScroll class="new-quotation__regularinput" formControlName="delivery_fee"  name="delivery_fee" >
										<div class="discount-type-toggle">
											<span class="discount-type active ptb-13" data-type="sar" [innerHtml]="userInfo?.currency_symbol"></span>
										</div>
									</div>
									<span class="field-error" *ngIf="invoiceForm.controls.delivery_fee.errors?.min" i18n="@@error.invalid_number">Invalid</span>
								</div>
							</fieldset>
							<div class="new-create__items">
								<fieldset class="add-items" [ngClass]="{'has-error': submitted && invoiceForm.controls.currency.errors && invoiceForm.controls.currency.errors.required}">
									<label for="currency-input" i18n="@@invoices.currency">Currency</label>
									<select app-select2
										[options]="{
												ajax: {url: currencyListApi},
												idColumn: 'id',
												textColumn: 'currency_full_name'
											}"
										(itemSelected)="onChangeCurrency($event)"
										[selected]="selectedCurrency ? {id: selectedCurrency.id, text: selectedCurrency.currency_full_name} : null"
										i18n-data-placeholder="@@option.select_currency"
										data-placeholder="Select Currency"
										formControlName="currency"
										class="search-to new-create__regularinput">
										<option></option>
									</select>
									<span class="field-error" i18n="@@error.required">* Required</span>
								</fieldset>
							</div>

						</div>
					</div>
				</div>

				<div class="new-create__preview">
					<h3 class="d-none-none" i18n="@@invoices.preview">Preview</h3>

					<div class="new-create__preview-body">
						<div class="new-create__preview-body--header">
							<ng-container *ngIf="invoiceForm?.value?.invoice_type == 'b2b'; else b2c">
								<div class="preview_header_logo">
									<img src="{{ userInfo?.logo }}" alt="" loading="lazy">
									<div class="preview_header_name gap-3">
										<h3>
											<ng-container *ngIf="(taxAmount != 0)">
												<p i18n="@@invoices.tax_invoice">Tax Invoice</p>
											</ng-container>

											<span>#{{ invoiceForm?.value?.invoice_number }}</span>
										</h3>
										<div class="customer_date_block">
											<span i18n="@@invoices.invoice_date">Date</span>
											<span>{{ invoiceForm?.value?.invoice_date }} {{ invoiceForm?.value?.invoice_time }}</span>
										</div>
									</div>
								</div>
							</ng-container>
							<ng-template #b2c>
								<div class="preview_header_logo">
									<img src="{{ userInfo?.logo }}" alt="" loading="lazy">
                  <!-- <div class="preview_header_name gap-3">
										<h3>
											<ng-container *ngIf="(taxAmount != 0)">
												<ng-container *ngIf="(userInfo.country_id == COUNTRIES.SAUDI_ARABIA); else outSideSaudi">
													<p i18n="@@invoices.simplified_tax_invoice">Simplified Tax Invoice</p>
												</ng-container>
												<ng-template #outSideSaudi>
													<p i18n="@@invoices.tax_invoice">Tax Invoice</p>
												</ng-template>
											</ng-container>
										</h3>
									</div> -->
									<div class="preview_header_name">
										<h3>{{ userInfo?.business_name | titlecase }}</h3>
										<span class="preview_header_name_address">
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
												<path d="M7.99984 8.66659C9.10441 8.66659 9.99984 7.77115 9.99984 6.66659C9.99984 5.56202 9.10441 4.66659 7.99984 4.66659C6.89527 4.66659 5.99984 5.56202 5.99984 6.66659C5.99984 7.77115 6.89527 8.66659 7.99984 8.66659Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
												<path d="M7.99984 14.6666C10.6665 11.9999 13.3332 9.6121 13.3332 6.66659C13.3332 3.72107 10.9454 1.33325 7.99984 1.33325C5.05432 1.33325 2.6665 3.72107 2.6665 6.66659C2.6665 9.6121 5.33317 11.9999 7.99984 14.6666Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
											{{ userInfo?.address }}
										</span>
									</div>
								</div>
								<div class="preview_header_customer_details">
									<div class="customer_name_block">
										<span i18n="@@invoices.bill_to">Bill to</span>
										<span>{{ selectedClient?.full_name }}</span>
									</div>
									<div class="customer_date_block">
										<span i18n="@@invoices.invoice_date">Date</span>
										<span>{{ invoiceForm?.value?.invoice_date }}</span>
									</div>
								</div>
							</ng-template>
						</div>

						<ng-container *ngIf="invoiceForm?.value?.invoice_type == 'b2b'; else b2cSellerInfo">
							<div class="new-create__preview-body--details flex-row flex-none-column">
								<div class="seller_info">
									<h4 i18n="@@invoices.seller_info">Seller info</h4>
									<div class="seller_info_block">
										<div class="invoice_number">
											<span i18n="@@invoices.name">Name</span>
											<span>{{ userInfo?.business_name | titlecase }}</span>
										</div>
										<div class="invoice_number">
											<span i18n="@@invoices.address">Address</span>
											<span>{{ userInfo?.address }}</span>
										</div>
										<div class="invoice_number">
											<span i18n="@@invoices.vat_number">VAT Number</span>
											<span>{{ userInfo?.tax_number }}</span>
										</div>
										<div class="invoice_number">
											<span i18n="@@invoices.cr_number">CR number</span>
											<span>{{ userInfo?.cr_number }}</span>
										</div>
									</div>
								</div>
								<div class="seller_info">
									<h4 i18n="@@invoices.buyer_info">Buyer info</h4>
									<div class="seller_info_block">
										<div class="invoice_number">
											<span i18n="@@invoices.name">Name</span>
											<span>{{ invoiceForm?.value?.buyer_first_name }} {{ invoiceForm?.value?.buyer_last_name }}</span>
										</div>
										<div class="invoice_number">
											<span i18n="@@invoices.address">Address</span>
											<span>{{ invoiceForm?.value?.buyer_address }}</span>
										</div>
										<div class="invoice_number">
											<span i18n="@@invoices.vat_number">VAT Number</span>
											<span>{{ invoiceForm?.value?.buyer_vat_number }}</span>
										</div>
										<div class="invoice_number">
											<span i18n="@@invoices.cr_number">CR number</span>
											<span>{{ invoiceForm?.value?.buyer_cr_number }}</span>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
						<ng-template #b2cSellerInfo>
							<div class="new-create__preview-body--details">
								<div class="invoice_number">
									<span i18n="@@invoices.invoice_number">Invoice Number</span>
									<span>{{ invoiceForm?.value?.invoice_number }}</span>
								</div>
								<div class="invoice_number">
									<span i18n="@@invoices.vat_number">VAT Number</span>
									<span>{{ userInfo?.tax_number }}</span>
								</div>
								<div class="invoice_number">
									<span i18n="@@invoices.cr_number">CR number</span>
									<span>{{ userInfo?.cr_number }}</span>
								</div>
							</div>
						</ng-template>

						<div class="table-wrapper">
							<table class="marketing_table shadow-none-none">
								<thead>
									<tr>
										<th i18n="@@invoices.item">Item</th>
										<th i18n="@@invoices.description">Description</th>
										<th i18n="@@invoices.quantity">Quantity</th>
										<th i18n="@@invoices.unit_price">Unit Price</th>
										<th i18n="@@invoices.amount">Amount</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngIf="deliverables?.controls.length; else noRecords">
										<tr *ngFor="let deliverable of deliverables?.controls; index as $index">
											<td data-th="Item">
												<span>{{ deliverable.controls.title.value | titlecase }}</span>
											</td>
											<td data-th="Description" class="description">
												<span>{{ deliverable.controls.description.value | titlecase }}</span>
											</td>
											<td data-th="Quantity">
												<span>{{ deliverable?.controls?.quantity?.value }}X</span>
											</td>
											<td data-th="Unit Price">
												<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ deliverable.controls.rate.value }}</span>
											</td>
											<td data-th="Amount" class="p-none-0 border-bottom-none-0">
												<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ (deliverable?.controls?.quantity?.value * deliverable.controls.rate.value | number:'.2') }}</span>
											</td>
										</tr>

										<tr class="total-vat d-none-none" *ngIf="taxAmount">
											<td colspan="5" class="border-0">
												<div class="d-flex align-items-center w-100 justify-content-between">
													<ng-container i18n="@@invoices.sub_total">Sub Total</ng-container>
													<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ subTotalDeliverableCost | number:'.2' }}</span>
												</div>
											</td>
										</tr>
										<tr class="total-vat d-none-none" *ngIf="taxAmount">
											<td colspan="5" class="border-0">
												<div class="d-flex align-items-center w-100 justify-content-between">
													<ng-container i18n="@@tax">Total VAT</ng-container>
													({{invoiceForm.controls.tax_percent.value}}%)
													<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ taxAmount | number:'.2' }}</span>
												</div>
											</td>
										</tr>
										<tr class="total-vat d-none-none" *ngIf="invoiceDiscountAmount">
											<td colspan="5" class="border-0">
												<div class="d-flex align-items-center w-100 justify-content-between">
													<ng-container i18n="@@invoices.discount">Discount</ng-container>
													<ng-container *ngIf="discountType == 'percentage'; else elseDiscountType">
														({{invoiceForm.controls.discount.value}}%)
													</ng-container>
													<ng-template #elseDiscountType>
														(<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{invoiceForm.controls.discount.value | number:'.2' }})
													</ng-template>
													<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ invoiceDiscountAmount | number:'.2' }}</span>
												</div>
											</td>
										</tr>
										<tr class="total-vat d-none-none" *ngIf="invoiceDeliveryFeeAmount">
											<td colspan="5" class="border-0">
												<div class="d-flex align-items-center w-100 justify-content-between">
													<ng-container i18n="@@invoices.delivery_fees">Delivery Fees</ng-container>
													<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ invoiceDeliveryFeeAmount | number:'.2' }}</span>
												</div>
											</td>
										</tr>
										<tr class="total-due d-none-none">
											<td colspan="5">
												<div class="d-flex align-items-center w-100 justify-content-between">
													<ng-container i18n="@@invoices.preview.total_amount_due">Total Amount Due</ng-container>
													<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ invoiceTotal | number:'.2' }}</span>
												</div>
											</td>
										</tr>
									</ng-container>
									<ng-template #noRecords>
										<tr>
											<td colspan="5" class="text-center">
												<span i18n="@@common.no_record_found">No records found</span>
											</td>
										</tr>
									</ng-template>
								</tbody>
							</table>
							<div class="total-vat2">
								<div class="d-flex align-items-center w-100 justify-content-between">
									<ng-container i18n="@@tax">Total VAT</ng-container>
									<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ taxAmount | number:'.2' }}</span>
								</div>
							</div>
							<div class="total-due2">
								<div class="d-flex align-items-center w-100 justify-content-between">
									<ng-container i18n="@@invoices.preview.total_amount_due">Total Amount Due</ng-container>
									<span><span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ invoiceTotal | number:'.2' }}</span>
								</div>
							</div>
						</div>

						<div class="additional_info align-items-start">
							<ng-container *ngIf="defaultAdditionalInfo">
								<h4 i18n="@@invoices.additional_info">Additional Info</h4>
								<span class="pre-text">{{ defaultAdditionalInfo }}</span>
							</ng-container>

							<ng-container *ngIf="!zatcaEnabled && (qrCodeBase64 && taxInvoice)">
								<qr-code class="text-center" value="{{ qrCodeBase64 }}" size="150" errorCorrectionLevel="M"></qr-code>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="new-create_footer">
			<div class="secondary_btn" (click)="saveAsDraft()" i18n="@@invoices.save_as_draft">Save as draft</div>
			<!-- <div class="secondary_btn" (click)="saveInvoiceSend()" i18n="@@invoices.convert_to_invoice_send">Convert to invoice & send</div> -->
			<div class="secondary_btn" (click)="saveInvoice()" i18n="@@invoices.convert_to_invoice">Convert to invoice</div>
			<!-- <div class="primary_btn" (click)="saveInvoice()" i18n="@@invoices.convert_to_invoice">Convert to invoice</div> -->
		</div>
	</form>
</div>
